module.exports = "./img/c82f2ef4aafbfe987aa9b53b01eca0fa.png";